import React, { useState, useEffect } from "react";
import Chart from "react-apexcharts";

export const SchemeTypeWise = ({ schemeType, isDarkMode }) => {
  console.log('schemeType', schemeType);

  // const schemeType = [
  //   { "Fund Type": "Equity - ELSS", Holding: "80" },
  //   { "Fund Type": "Equity - Large Cap", Holding: "12" },
  //   { "Fund Type": "Equity - Multi Cap", Holding: "8" },
  //   { "Fund Type": "Debt - Income Fund", Holding: "10" },
  //   { "Fund Type": "Debt - Liquid Fund", Holding: "15" },
  //   // { "Fund Type": "Hybrid - Balanced", Holding: "5" },
  //   // { "Fund Type": "Equity - ELSS", Holding: "50" },
  //   // { "Fund Type": "Equity - Large Cap", Holding: "12" },
  //   // { "Fund Type": "Equity - Multi Cap", Holding: "8" },
  //   // { "Fund Type": "Debt - Income Fund", Holding: "4" },
  //   // { "Fund Type": "Debt - Liquid Fund", Holding: "15" },
  //   // { "Fund Type": "Hybrid - Balanced", Holding: "5" },
  // ];

  const [series, setSeries] = useState([]);
  const [labels, setLabels] = useState([]);
  const [total, setTotal] = useState(0);

  useEffect(() => {
    // Step 1: Prepare raw data
    const rawHoldings = schemeType?.map((item) => parseFloat(item.Holding) || 0);
    const rawLabels = schemeType?.map((item) => item["Fund Type"] || "Unknown");

    // Step 2: Filter out items where holding < 1
    const filteredData = rawHoldings
      ?.map((value, index) => ({ value, label: rawLabels[index] }))
      ?.filter((item) => item.value > 0);


    // Step 3: Separate filtered values
    const filteredHoldings = filteredData?.map((item) => item.value);
    const filteredLabels = filteredData?.map((item) => item.label);
    const total = filteredHoldings?.reduce((sum, curr) => sum + curr, 0);

    console.log("Filtered", filteredData, filteredLabels, filteredHoldings);

    // Step 4: Set state
    setSeries(filteredHoldings);
    setLabels(filteredLabels);
    setTotal(total);
  }, [schemeType]); // Dependency added to update when schemeType changes

  // const options = {
  //   chart: {
  //     type: "donut",
  //   },
  //   labels: labels,
  //   colors: [
  //     "#123200",
  //     "#03641B",
  //     "#047D22",
  //     "#059529",
  //     "#2DC653",
  //     "#32F964",
  //     "#59FA81",
  //     "#80FC9F",
  //     "#CCFF33",
  //     "#F8AA24",
  //   ],
  //   plotOptions: {
  //     pie: {
  //       donut: {
  //         size: "90%",
  //         labels: {
  //           show: true,
  //           name: {
  //             show: true,
  //             offsetY: -10,
  //             fontSize: "16px",
  //             formatter: () => "Funds",
  //           },
  //           value: {
  //             show: false,
  //           },
  //           total: {
  //             show: true,
  //             label: "Total",
  //             color: isDarkMode ? "#fff" : "#373D3F",
  //             formatter: () => `${total.toFixed(2)}%`,
  //             fontSize: "16px",
  //           },
  //         },
  //       },
  //     },
  //   },
  //   dataLabels: {
  //     enabled: false,
  //   },
  //   legend: {
  //     show: false,
  //   },
  //   tooltip: {
  //     theme: "dark",
  //     y: {
  //       formatter: (value) => `${value.toFixed(2)}%`,
  //     },
  //   },
  // };
  const options = {
    chart: { type: "donut" },
    labels,
    colors: [
      "#cfcf0e", "#26b99a", "#3498db", "#2bd927", "#267e24", "#60BD3B", "#59FA81", "#80FC9F", "#4DBD8F",
    ],
    plotOptions: {
      pie: {
        donut: {
          size: "80%",
          labels: {
            show: true,
            total: {
              show: false,
              label: 'Total',
              formatter: () => `${total.toFixed(2)}%`,
              color: "#000",
              fontSize: "20px",
            },
            name: {
              show: true,
              offsetY: -5,
              fontSize: "16px",
              formatter: () => "Funds",
            },
            value: {
              show: true,
              fontSize: "20px",
              formatter: (val) => `${val}%`, // 🔹 show hovered slice’s % only
            },
          },
        },
      },
    },
    dataLabels: { enabled: false },
    legend: { show: false },
    tooltip: {
      theme: "dark",
      custom: ({ series, seriesIndex, w }) => `<div style="background-color: #0009; padding: 10px; border-radius: 5px;">
        <span>${w.globals.labels[seriesIndex]}: ${series[seriesIndex]}%</span>
      </div>`,
    },
    responsive: [
      {
        breakpoint: 992, // for tablets
        options: {
          chart: {
            width: 300,
          },
        },
      },
      {
        breakpoint: 768, // for mobile
        options: {
          chart: {
            // width: 250,
          },
        },
      },
    ],
  };

  return (
    <div className="row custom-donut-row">

      {/* Chart column */}
      <div className="col-md-12 col-lg-7 d-flex align-items-center justify-content-center">
        <Chart options={options} series={series} type="donut" width="100%" />
      </div>

      {/* Legend and Data */}
      <div className="col-lg-5 pt-3 ">
        <div className="scroll-container" style={{ maxHeight: "250px" }}>
          {schemeType?.map((item, index) => {
            const holding = parseFloat(item.Holding) || 0;
            if (holding <= 0) return null; // ✅ include 0.44 Debt

            return (
              <div key={index} className="legend-item">
                <div className="d-flex align-items-center">
                  <span
                    className="legend-color"
                    style={{
                      backgroundColor:
                        options.colors[index % options.colors.length],
                    }}
                  ></span>
                  <span className="legend-text refer">{item["Fund Type"]}</span>
                </div>
                <span className="legend-percentage refer">
                  {holding.toFixed(2)}%
                </span>
              </div>
            );
          })}

        </div>
      </div>

    </div>
  );
};

export default SchemeTypeWise;
